export default{
  title: 'FEATURED CASE STUDIES',
  description: 'See how maesinfo enterprise architecture services help companies achieve digital transformation.',
  caseList: [
    {
      imgUrl: require('../../assets/images/cases/1.jpg'),
      title: 'Wisdom park management system',
      description: `
      1. Intelligent office system and personnel management system <br/>
      2. Intelligent property system - access control system, intelligent parking lot, intelligent electric power system, enterprise management system <br/>
      3. Intelligent security warning system
      `
    },
    {
      imgUrl: require('../../assets/images/cases/2.jpg'),
      title: 'Enterprise Production Information management system',
      description: `
      1. Technics process automation process management and data acquisition system <br/>
      2. Inventory control, loss Analysis system and customer tracking system <br/>
      3. Report data generation system and financial system
      `
    },
    {
      imgUrl: require('../../assets/images/cases/3.jpg'),
      title: 'Financial management system',
      description: `
      1. The independent core system in transaction, financial management and accounting system <br/>
      2. International trade and unity payment platform <br/>
      3. Channel integration and ODS data platform
      `
    },
    {
      imgUrl: require('../../assets/images/cases/4.jpg'),
      title: 'Futures trading platform',
      description: `
      1. Enterprise-level data warehouse, enterprise unity data dictionary and Unity data caliber <br/>
      2. Security situation awareness platform and IT operation and management platform <br/>
      3. Unity monitoring and warning information display platform
      `
    },
    {
      imgUrl: require('../../assets/images/cases/5.jpg'),
      title: 'Data application platform (Medical Industry)',
      description: `
      1.Digital intelligent pension cloud platform <br/>
      2.Application cloud platform for medical industry <br/>
      3. Medical image analysis platform
      `
    },
    {
      imgUrl: require('../../assets/images/cases/6.jpg'),
      title: 'Overseas e-commerce trading platform',
      description: `
      1. CRMsy sytem <br/>
      2. ICommercial opportunity analysis data platform <br/>
      3. Online shopping wesites and mobile apps
      `
    },
    {
      imgUrl: require('../../assets/images/cases/7.jpg'),
      title: 'Global Cross-border service trading platform',
      description: `
      1. Melinked Cross-border service trading platform, <br/>
      2. B2B marketing management platform <br/>
      3. International trade payment and settlement platform
      `
    },
    {
      imgUrl: require('../../assets/images/cases/8.jpg'),
      title: 'Online education platform',
      description: `
      1. Live education platform, teachers and students can share courseware in real time <br/>
      2. Social communication platform and support multiple mobile terminals <br/>
      3. AI digital education cloud service platform
      `
    }
  ]
}
